import type { PersonaDataWindowPreset, PersonaOpportunityQueryTuning } from "../types/persona-opportunities.types.js";

/** Mirror engine defaults (services/opportunities-engine persona-opportunities constants). */
export const PERSONA_OPPORTUNITY_DEFAULT_DAYS_BACK = 60;
export const PERSONA_OPPORTUNITY_DEFAULT_CANDIDATE_POOL_SIZE = 50;
export const PERSONA_OPPORTUNITY_DEFAULT_ANGLES_RETURNED = 10;
export const PERSONA_OPPORTUNITY_DEFAULT_MAX_ANGLES_PER_FEATURE = 3;
export const PERSONA_OPPORTUNITY_DEFAULT_MIN_BRANDS_PER_FEATURE = 2;
export const PERSONA_OPPORTUNITY_DEFAULT_STICK_DAYS = 14;

export const DEFAULT_PERSONA_DATA_WINDOW_PRESET: PersonaDataWindowPreset = "last_60_days";

export const PERSONA_DATA_WINDOW_DAYS: Record<Exclude<PersonaDataWindowPreset, "custom">, number> = {
  last_30_days: 30,
  last_60_days: 60,
  last_90_days: 90,
};

export function createDefaultPersonaOpportunityQueryTuning(): PersonaOpportunityQueryTuning {
  return {
    candidatePoolSize: PERSONA_OPPORTUNITY_DEFAULT_CANDIDATE_POOL_SIZE,
    anglesReturned: PERSONA_OPPORTUNITY_DEFAULT_ANGLES_RETURNED,
    maxAnglesPerFeature: PERSONA_OPPORTUNITY_DEFAULT_MAX_ANGLES_PER_FEATURE,
    minBrandsPerFeature: PERSONA_OPPORTUNITY_DEFAULT_MIN_BRANDS_PER_FEATURE,
    stickDays: PERSONA_OPPORTUNITY_DEFAULT_STICK_DAYS,
  };
}
